const showAsLocked = (bannerSet, userEntityId, allowUnavailability) => {
  if (allowUnavailability) return false;
  return (
    !Boolean(bannerSet.permissions.find(p => p.includes(`WRITE_${userEntityId}`))) ||
    Boolean(bannerSet.lockOwner && bannerSet.lockOwner.length)
  );
};

export default showAsLocked;
